


<template>
  <div class="eva">
      <Nav></Nav>

    <div class="hander">
      <span :class="type == 2 && 'on'" @click="type = 2">全部</span>
      <span :class="type == 1 && 'on'" @click="type = 1">好评</span>
      <span :class="type == 0 && 'on'" @click="type = 0">中评</span>
      <span :class="type == -1 && 'on'" @click="type = -1">差评</span>
    </div>
    <div class="evaluateBox">
      <div v-if="!list.length" style="padding-top:200px;color:#999;text-align:center;font-size:16px;">暂无数据</div>

      <div class="eva_li" v-for="(item,index) in list" :key="index">
        <div class="top">
          <img :src="item.users_avatarurl" alt />
          <span class="name">{{ item.users_nickname }}</span>
        </div>
        <div class="time">
          <span>{{ item.add_day }}</span>
          <span>{{ item.products_sku_title }}</span>
        </div>
        <p>{{ item.content }}</p>
        <div class="imgBox" v-if="item._child">
          <div class="inner">
            <img :src="el.pic" v-for="(el,key) in item._child" :key="el.id" @click="openImg(index,key)" />
          </div>
        </div>
        <div class="store" v-if="item.reply_content">商家回复：{{ item.reply_content }}</div>
      </div>
    </div>
    <GoodsShop />
  </div>
</template>

<style lang="less" scoped>
.eva {
  .hander {
    height: 80px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    background-color: #fff;
    padding: 0 24px;
    span {
      padding: 0 25px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      border-radius: 23px;
      font-size: 24px;
      color: #666;
      border: 1px solid #ddd;
      margin-right: 20px;
    }
    .on {
      color: #e42129;
      border: 1px solid #e42129;
      background-color: #ffeced;
    }
  }
  .evaluateBox {
    background: #fff;
    width: 750px;
    box-sizing: border-box;
    .eva_li {
      border-top: 1px solid #eee;
      width: 100%;
      box-sizing: border-box;
      padding: 30px 24px;
      .top {
        display: flex;
        align-items: center;
        img {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          margin-right: 15px;
        }
        .name {
          font-size: 24px;
          color: #333;
        }
      }
      .time {
        height: 60px;
        display: flex;
        align-items: center;
        span {
          font-size: 22px;
          color: #666;
          margin-right: 50px;
        }
      }
      p {
        font-size: 24px;
        color: #333;
        margin: 10px 0;
      }
      .imgBox {
        width: 100%;
        padding: 0 24px;
        box-sizing: border-box;
        overflow: hidden;
        margin-top: 20px;
        .inner {
          display: flex;
          align-items: center;
          img {
            width: 140px;
            height: 140px;
            border: 1px solid #eee;
            margin-right: 20px;
          }
        }
      }
      .store{
        width: 100%;
        background-color: #f2f2f2;
        box-sizing: border-box;
        padding: 25px;
        font-size: 24px;
        line-height: 32px;
        color: #666;
      }
    }
  }
}
</style>

<script>
import GoodsShop from "../component/goods/goodsShop";
import {ImagePreview} from 'vant'

export default {
  components: {
    GoodsShop
  },
  data() {
    return {
      page: 1,
      evaList: [],
      type: 2
    };
  },
  computed: {
    list() {
      if (this.type == 2) {
        return this.evaList;
      } else {
        return this.evaList.filter(item => item.evaluate == this.type);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    let { id } = to.query;
    next(vm => {
      vm.getEvaList(id);
    });
  },
  methods: {
    openImg(evaIndex,imgId){

      // console.log(index)
      console.log(this.evaList)

      let list = this.evaList[evaIndex]._child.map(item=>item.pic)

      ImagePreview({
        images:list,
        startPosition:imgId
      })
    },
    getEvaList(id) {
      this.$http({
        url: "evaluateList",
        data: {
          id,
          page: this.page
        }
      }).then(res => {
        console.log(res);

        if (!res.nowPage) return;
        this.evaList =
          res.nowPage == 1 ? res._list : this.evaList.concat(res._list);
      });
    }
  }
};
</script>
